import {pxToEm} from "utils/styles/style_helpers";

export default theme =>({
    agreementform:{
        // maxWidth: pxToEm(960),
        '& iframe':{
            width: '100%',
            height: pxToEm(498)
        }
    }
})